import React, { useEffect, useMemo } from 'react';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

const ArticleDetailUI = dynamic(() => import('./ContentUI'), { ssr: true });

const ArticleDetail = ({ data }: { data: any }) => {
  const { isBlogWeb } = useConfigProvider();
  const router = useRouter();

  useEffect(() => {
    if (!isBlogWeb) {
      router.push('/');
    }
  }, []);

  const getContent = useMemo(() => {
    return (
      <ArticleDetailUI
        model={data['model']}
        // articleList={data['articleList']}
        contentData={data['contentData']}
        recommendTags={data['recommendTags']}
      />
    );
  }, [data]);

  if (!isBlogWeb) {
    return <></>;
  }
  return <>{getContent}</>;
};

export default ArticleDetail;
